import { Suspense } from 'react';

import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { FeedbackV3, useV3 } from '@/lib/v3';

/**
 * Il guscio del Feedback PROTETTO: l'unica cosa che `AppShell` monta del Feedback (UNA volta, subito dopo `<GuscioProtetto />`; lo tiene `tools/verify-feedback.ts`).
 *
 * `null` quando il chunk non esiste (produzione, o staging senza il flag: `FeedbackV3` e' `undefined`) o quando la v3 NON e' accesa (`useV3()`: flag di build, ruolo `beta`, interruttore): fuori dalla v3 non
 * monta niente e il pulsante dei minigiochi resta quello di sempre (D1). Altrimenti il guscio lazy sta dentro un `ErrorBoundary` LOCALE e un `Suspense`: un errore del Feedback (render, chunk che non si
 * carica) non deve buttare giu' tutta la shell. ⚠️ Il ripiego e' un frammento VUOTO e non `null`: `ErrorBoundary` fa `fallback ?? <schermata d'errore a tutto schermo>`, e `null ?? x` e' `x`.
 * Il codice non porta nessun marcatore del Feedback: in produzione resta nel bundle, vuoto.
 */
export function GuscioFeedbackProtetto() {
  const v3 = useV3();
  if (!FeedbackV3 || !v3) return null;
  return (
    <ErrorBoundary fallback={<></>}>
      <Suspense fallback={null}>
        <FeedbackV3 />
      </Suspense>
    </ErrorBoundary>
  );
}
